import { render, staticRenderFns } from "./Export_product_detail.vue?vue&type=template&id=3123cbe8&scoped=true&"
import script from "./Export_product_detail.vue?vue&type=script&lang=js&"
export * from "./Export_product_detail.vue?vue&type=script&lang=js&"
import style0 from "./Export_product_detail.vue?vue&type=style&index=0&id=3123cbe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123cbe8",
  null
  
)

export default component.exports